import { Target2SellConfigDTO } from './Target2SellConfigDTO';

export type Target2SellConfigValue = {
    pageId: {
        pdp?: string;
        popUpBasket?: string;
    };
};

export type PageType = keyof Target2SellConfigValue['pageId'];

export const mapTarget2SellConfig = (dto: Target2SellConfigDTO): Target2SellConfigValue => {
    const pageSpaceJson = dto.T2SPageSpace && JSON.parse(dto.T2SPageSpace);

    return {
        pageId: {
            pdp: pageSpaceJson?.PDP?.page_id,
            popUpBasket: pageSpaceJson?.POP_UP_CART?.page_id,
        },
    };
};
